import { useLocation } from "react-router-dom"
import { Hammer } from "lucide-react"
import { EmptyState } from "@/components/common/EmptyState"
import { PageHeader } from "@/components/common/PageHeader"
import { Badge } from "@/components/ui/badge"
import { Card, CardContent } from "@/components/ui/card"
import { findNavItemByPath } from "@/components/layout/nav-config"

export function ComingSoonPage() {
  const { pathname } = useLocation()
  const item = findNavItemByPath(pathname)
  const title = item?.label ?? "Moduł"
  const description = item?.description ?? "Ten moduł jest w przygotowaniu."

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title={title}
        subtitle={description}
        actions={<Badge variant="secondary">wkrótce</Badge>}
      />
      <Card>
        <CardContent>
          <EmptyState
            icon={Hammer}
            title="Moduł w budowie"
            description="Pracujemy nad tym obszarem. Wrócimy z nim w kolejnej iteracji - status w roadmapie projektu."
          />
        </CardContent>
      </Card>
    </div>
  )
}
